import { css } from 'lit';

export default css`
  :host {
    align-self: stretch;
    display: block;
  }

  .dropzone {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    padding: var(--spacing-md);
    margin-bottom: var(--spacing-md);
    border-radius: var(--Radius---radius-lg, 10px);
    border: 1px dashed var(--color-app-dam);
    background: var(--color-gray-1);
    cursor: pointer;
    transition: background-color 0.2s, border-color 0.2s;
    text-align: center;
  }

  :host([dragging]) .dropzone {
    background-color: var(--color-gray-2);
    border-color: var(--color-app-dam);
  }

  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .upload-modal {
    background-color: var(--surface-raised);
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    width: auto;
    min-width: 768px;
    max-height: 90vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .modal-dropzone {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: var(--spacing-sm);
    border: 1px dashed var(--color-app-dam);
    background: var(--color-gray-1);
    cursor: pointer;
    transition: background-color 0.2s, border-color 0.2s;
    margin-bottom: 20px;
  }

  :host([dragging]) .modal-dropzone {
    background-color: var(--color-gray-2);
    border-color: var(--color-app-dam);
  }

  .file-list {
    display: grid;
    grid-template-columns: 110px 1fr 90px 50px;
    gap: 0px;
    background: var(--surface-raised);
  }

  .header-cell {
    background: transparent;
    padding: 10px;
    text-align: center;
    font-weight: bold;
  }

  .file-type-cell {
    background: var(--color-gray-1);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px;
    gap: 10px;
  }

  .file-name {
    background: var(--color-gray-1);
    padding: 10px;
    text-align: left;
  }

  .file-size {
    background: var(--color-gray-1);
    padding: 10px;
    text-align: right;
  }

  .delete-icon-cell {
    background: var(--color-gray-1);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
  }

  .file-progress-cell {
    background: var(--color-gray-1);
    padding: 10px;
    display: flex;
    align-items: center;
  }

  .check-icon {
    color: var(--color-green-light, #00B37E);
    margin-right: 5px;
  }

  .icon {
    color: var(--color-app-dam);
  }

  .delete-icon {
    color: var(--color-red-light, #FF2B32);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .actions {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    gap: 18px;
  }

  .file-type-cell,
  .file-progress-cell,
  .delete-icon-cell {
    margin-bottom: 1px;
  }

  .file-name {
    margin-bottom: 0;
  }

  .upload-pill {
    position: fixed;
    top: 10px;
    right: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 250px;
    padding: 10px;
    border-radius: var(--radius-md);
    border: 1px solid var(--color-gray-2);
    background: var(--color-gray-1);
    box-shadow: -1px 5px 15px -5px rgba(65, 65, 65, 0.10);
    cursor: pointer;
  }

  .upload-pill.expanded {
    width: 485px;
    border-radius: var(--spacing-sm) var(--spacing-sm) 0px 0px;
    border-left: 1px solid var(--color-gray-2);
    border-right: 1px solid var(--color-gray-2);
    border-top: 1px solid var(--color-gray-2);
    background: var(--surface-raised);
    justify-content: space-between;
    text-align: center;
  }

  .dropdown {
    position: absolute;
    width: 485px;
    top: 100%;
    left: -1px;
    display: flex;
    flex-direction: column;
    gap: 1px;
    background-color: var(--surface-raised);
    border-bottom: 1px solid var(--color-gray-2);
    border-left: 1px solid var(--color-gray-2);
    border-right: 1px solid var(--color-gray-2);
    border-radius: 0px 0px var(--spacing-sm) var(--spacing-sm);
    padding: 10px;
    max-height: 200px;
    overflow-y: auto;
  }

  .file-entry {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 5px;
    background: var(--color-gray-1);
    border-bottom: 1px solid var(--border-subtle);
    border-top: 1px solid var(--border-subtle);
  }

  .status-icon {
    margin-right: 10px;
  }

  .file-name {
    flex-grow: 1;
  }

  .delete-icon {
    cursor: pointer;
    color: var(--color-red-light, #FF2B32);
  }

  .file-entry-first {
    border-radius: var(--spacing-sm) var(--spacing-sm) 0px 0px;
  }

  .file-entry-last {
    border-radius: 0px 0px var(--spacing-sm) var(--spacing-sm);
  }

  .file-entry-only {
    border-radius: var(--spacing-sm) var(--spacing-sm) var(--spacing-sm) var(--spacing-sm);
  }

  .file-type-info {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-right: 10px;
  }

  .file-type-icon {
    color: var(--color-app-dam);
    width: 16px;
    height: 16px;
  }

	studio-upload-meta img[slot="thumbnail"] {
    width: 100%;
    height: auto;
    max-height: 300px;
    object-fit: contain;
    object-position: center;
  }

	studio-upload-meta video[slot="thumbnail"] {
	width: 100%;
	height: auto;
	max-height: 300px;
	object-fit: contain;
	object-position: center;
}

.meta-container studio-upload-meta.hidden {
  display: none;
}


`;
